import React, { useState, useEffect, useCallback } from "react";
import "./tokenupdate.css";
import StatusFilter from "./StatusFilter"; // Updated filter component
import TokenUpdateTable from "./TokenUpdateTable";

function Tokenupdate() {
  const [items, setItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [filter, setFilter] = useState("all"); // Default filter

  const handleFilterChange = (status) => {
    setFilter(status);
  };
  const token = localStorage.getItem("authToken"); // get JWT from storage

  // Wrap fetchData in useCallback
  const fetchData = useCallback(async () => {
    try {
      const response = await fetch(
        "  https://quatdashboard.com:8084/api/tokenstatus",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      setItems(data);
      // Initial filtering
      applyFilter(filter, data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [filter]); // Add 'filter' as a dependency

  // const applyFilter = (filter, data) => {
  //   if (filter === "all") {
  //     setFilteredItems(data);
  //   } else {
  //     // Replace 'status' with the correct field name if necessary
  //     setFilteredItems(data.filter((item) => item.status === filter));
  //   }
  // };
  const applyFilter = (filter, data) => {
    if (filter === "all") {
      setFilteredItems(data);
    } else if (filter === "zerodha" || filter === "flattrade") {
      setFilteredItems(data.filter((item) => item.broker === filter));
    } else if (filter === "success") {
      setFilteredItems(data.filter((item) => item.status === true));
    } else if (filter === "failed") {
      setFilteredItems(data.filter((item) => item.status === false));
    } else {
      console.error("Unknown filter:", filter);
    }
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]); // Now fetchData is added as a dependency

  useEffect(() => {
    applyFilter(filter, items);
  }, [filter, items]);

  return (
    <div className="card recent-sales overflow-auto">
      <StatusFilter filterChange={handleFilterChange} />{" "}
      {/* Use StatusFilter */}
      <div className="card-body">
        <h5 className="card-title">
          Token Update <span>| {filter}</span>
        </h5>
        <TokenUpdateTable items={filteredItems} />
      </div>
    </div>
  );
}

export default Tokenupdate;
